import {
  GET_USERS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_USERS,
  UPDATE_USERS,
  DELETE_USERS,
} from "./actionType";

const INIT_STATE = {
  users: null,
  error: {},
  success: "",
};

const Users = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_USERS:
          return {
            ...state,
            users: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_USERS:
          return {
            ...state,
            success: "Successfully created",
            error: {},
          };
        case UPDATE_USERS:
          return {
            ...state,
            success: "Successfully updated",
            error: {},
          };
        case DELETE_USERS:
          return {
            ...state,
            success: "Successfully Deleted",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_USERS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case CREATE_USERS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case UPDATE_USERS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case DELETE_USERS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_USERS: {
      return {
        ...state,
      };
    }
    case CREATE_USERS: {
      return {
        ...state,
      };
    }
    case UPDATE_USERS:
      return {
        ...state,
      };
    case DELETE_USERS:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default Users;
